import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      Accueil: "Home",
      "Bienvenue sur le projet BToolzUp": "Welcome on the BToolzUp project",
      status: {
        scheduled: "Scheduled",
        pending: "Pending",
        processing: "Processing",
        processed: "Processed",
        error: "Error",
        ack_timeout: "ACK timeout",
        command_succeed: "Command succeed",
        command_failed: "Command failed",
        sent: "Sent",
      },
    },
  },
  fr: {
    translation: {
      activate: "Activé",
      desactivate: "Désactivé",
      desactivated: "Désactivé",
      status: {
        scheduled: "Planifié",
        pending: "En attente",
        processing: "En traitement",
        processed: "Traité",
        error: "Erreur",
        ack_timeout: "ACK délai dépassé",
        command_succeed: "Commande réussie",
        command_failed: "Commande échouée",
        command_applied: "Commande prise en compte",
        sent: "Envoyé",
        created: "Créé",
        creating_purposes: "Création des intentions",
        sending_purposes: "Envoi des intentions",
        polling_purposes: "Polling des intentions",
        done: "Terminé",
        retrying: "En cours d'envoi à nouveau",
        expired: "Expirée",
        cancelled: "Annulée",
      },
      campaign__operator__name: "Opérateur",
      state: "Statut",
      sending_date: "Date d'envoi",
      device: "Equipement",
      payload_clear: "Payload",
      campaign__header_config: "Header concentrateur",
      frame: "Trame",
      encrypted_frame: "Trame chiffrée",
      encapsulated_frame: "Trame encapsulée",
      operator_command_id: "ID commande opérateur",
      history: "Historique",
      created_at: "Créé le",
      force_update: "Forcer la mise à jour",
      affiliate_module_address: "Adresse du père",
      affiliate_module_type: "Type de module",
      affiliate_protocol: "Protocole",
      affiliate_module: "Module affilié",
      affiliate_type: "Type",
      module_address: "Adresse module",
      concentrator: "Concentrateur",
      repeaters: "Répéteurs",
      repeater: "Répéteur",
      channel: "Canal",
    },
  },
};

i18n
  .use(detector) // detect user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "fr",

    // keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
